var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7812 83.053L42.4825 86.1575V82.0978L43.4377 81.1426H50.124V85.9185V89.2617H42.9601L34.1244 85.4409L30.7812 83.053Z",
    fill: "#CDBDB2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9961 83.053L57.5338 86.1575V82.0978L56.5786 81.1426H49.8923V85.9185V89.2617H57.0562L65.8915 85.4409L68.9961 83.053Z",
    fill: "#CDBDB2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4552 74.2157L42.5 82.0958L43.6938 81.1406H56.1112L57.544 82.0958L56.5888 74.2157L54.6784 73.0215L45.1266 73.2605L43.4552 74.2157Z",
    fill: "#393939"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.998 20.9609L42.7292 34.3336L45.3562 73.2578H54.669L57.5346 34.3336L62.7881 20.9609H36.998Z",
    fill: "#F89C35"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9305 50.3397L5.24414 69.6821L21.9599 68.7269H32.7056V60.3692L32.228 43.1758L29.84 45.0862L11.9305 50.3397Z",
    fill: "#F89D35"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5859 52.4883L44.1673 52.9659L42.0183 62.9954L32.705 60.6074L24.5859 52.4883Z",
    fill: "#D87C30"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5859 52.7227L32.705 60.3642V68.0057L24.5859 52.7227Z",
    fill: "#EA8D3A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6973 60.5996L42.2492 62.9876L45.3537 73.2561L43.2043 74.4499L32.6973 68.2411V60.5996Z",
    fill: "#F89D35"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.6916 68.2422L30.7812 83.0476L43.4377 74.2123L32.6916 68.2422Z",
    fill: "#EB8F35"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.1536 52.957L45.3478 73.255L41.7656 62.8672L44.1536 52.957Z",
    fill: "#EA8E3A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7129 68.4812L32.6976 68.2422L30.7872 83.0476L21.7129 68.4812Z",
    fill: "#D87C30"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4977 89.5024L30.7952 83.0547L21.7209 68.4883L5.24414 69.6821L10.4977 89.5024Z",
    fill: "#EB8F35"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7345 34.3398L32.4665 42.9365L24.5859 52.4884L44.1673 53.205L42.7345 34.3398Z",
    fill: "#E8821E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.7812 83.0501L43.4377 74.2148L42.4825 81.8563V86.1547L33.8858 84.4829L30.7812 83.0501Z",
    fill: "#DFCEC3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.9961 83.0501L56.5786 74.2148L57.5338 81.8563V86.1547L66.1305 84.4829L68.9961 83.0501Z",
    fill: "#DFCEC3"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.916 57.2578L41.543 62.7504L32.2297 60.3624L38.916 57.2578Z",
    fill: "#393939"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2578 9.74023L42.7342 34.3361L37.2421 20.9635L10.2578 9.74023Z",
    fill: "#E88F35"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2554 9.74023L5.95703 22.8741L8.345 37.2019L6.67342 38.1571L9.06139 40.3063L7.15102 41.9778L9.77778 44.3658L8.1062 45.7986L11.927 50.5745L29.8367 45.0822C38.5926 38.0775 42.891 34.4955 42.7318 34.3363C42.5726 34.1771 31.7471 25.9784 10.2554 9.74023Z",
    fill: "#8E5A30"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.8664 50.3358L94.5527 69.6782L77.8369 68.723H67.0913V60.3653L67.5689 43.1719L69.9568 45.0823L87.8664 50.3358Z",
    fill: "#F89D35"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2109 52.4863L55.6295 52.9639L57.7785 62.9934L67.0918 60.6054L75.2109 52.4863Z",
    fill: "#D87C30"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.2109 52.7207L67.0918 60.3622V68.0037L75.2109 52.7207Z",
    fill: "#EA8D3A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1016 60.5977L57.5497 62.9856L54.4451 73.2542L56.5945 74.4479L67.1016 68.2392V60.5977Z",
    fill: "#F89D35"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.0838 68.2402L68.9941 83.0457L56.5767 74.449L67.0838 68.2402Z",
    fill: "#EB8F35"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6218 52.9609L54.4276 73.2589L58.0098 62.8711L55.6218 52.9609Z",
    fill: "#EA8E3A"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0762 68.4792L67.0915 68.2402L69.0019 83.0457L78.0762 68.4792Z",
    fill: "#D87C30"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.2992 89.4985L69.0016 83.0508L78.0759 68.4844L94.5527 69.6781L89.2992 89.4985Z",
    fill: "#EB8F35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0623 34.3379L67.3304 42.9346L75.2109 52.4865L55.6295 53.2031L57.0623 34.3379Z",
    fill: "#E8821E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.8828 57.2559L58.2559 62.7484L67.5691 60.3604L60.8828 57.2559Z",
    fill: "#393939"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5391 9.73828L57.0626 34.3342L62.5548 20.9615L89.5391 9.73828Z",
    fill: "#E88F35"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.5395 9.73828L93.8379 22.8721L91.4499 37.2L93.1215 38.1552L90.7335 40.3043L92.6439 41.9759L90.0171 44.3639L91.6887 45.7967L87.868 50.5726L69.9582 45.0803C61.2023 38.0756 56.904 34.4936 57.0632 34.3344C57.2224 34.1752 68.0478 25.9765 89.5395 9.73828Z",
    fill: "#8E5A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet1);
export default __webpack_public_path__ + "static/media/icon-wallet-1.c4a052fd523197d59ef94eb98358b1fa.svg";
export { ForwardRef as ReactComponent };